import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { adminLogin } from "../../lib/api";
import { BUSINESS } from "../../data/site";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { token } = await adminLogin(email, password);
      localStorage.setItem("yws_admin_token", token);
      navigate("/admin/dashboard");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center px-4" data-testid="admin-login">
      <div className="w-full max-w-sm bg-white rounded-2xl p-8 shadow-2xl">
        <img src={BUSINESS.logoLight} alt="Yavapai Waste Solutions" className="h-10 w-auto mx-auto mb-6" />
        <h1 className="font-heading font-bold text-xl text-slate-900 text-center mb-6">Admin Login</h1>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label htmlFor="admin-email" className="block text-sm font-medium text-slate-700 mb-1.5">Email</label>
            <input
              id="admin-email"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 rounded-lg border-2 border-slate-200 focus:border-sky-600 focus:outline-none transition-colors"
              data-testid="admin-email"
              required
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="block text-sm font-medium text-slate-700 mb-1.5">Password</label>
            <input
              id="admin-password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-lg border-2 border-slate-200 focus:border-sky-600 focus:outline-none transition-colors"
              data-testid="admin-password"
              required
            />
          </div>
          {error && (
            <p role="alert" className="text-sm font-medium text-slate-800 bg-slate-100 border border-slate-300 rounded-lg px-4 py-2.5" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 py-3 rounded-lg bg-sky-600 hover:bg-sky-700 disabled:opacity-60 text-white font-heading font-semibold transition-colors"
            data-testid="admin-login-submit"
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
